export enum ConsentStatusDisplay {
    INITIATED = 'Initiated',
    PENDING_PARTICIPANT_REVIEW = 'Pending Participant',
    PENDING_CRC_VERIFICATION = 'Pending CRC',
    PENDING_PI_APPROVAL = 'Pending Investigator',
    FULLY_EXECUTED = 'Fully Executed',
    EXPIRED = 'Expired',
    WITHDRAWN = 'Withdrawn',
    FAILED = 'Failed'
}

export interface ConsentStatusColor {
    bg: string;
    text: string;
}

export const getConsentStatusColor = (status: string): ConsentStatusColor => {
    switch (status) {
        case 'PENDING_PARTICIPANT_REVIEW':
            return { bg: 'bg-yellow-100', text: 'text-yellow-800' };
        case 'FULLY_EXECUTED':
            return { bg: 'bg-green-100', text: 'text-green-800' };
        case 'FAILED':
        case 'WITHDRAWN':
        case 'EXPIRED':
            return { bg: 'bg-red-100', text: 'text-red-800' };
        case 'PENDING_CRC_VERIFICATION':
        case 'PENDING_PI_APPROVAL':
            return { bg: 'bg-blue-100', text: 'text-blue-800' };
        default:
            return { bg: 'bg-gray-100', text: 'text-gray-800' };
    }
};

export enum NotificationCategoryIcon {
    HAS_LINK = 'near_me',
    DEFAULT = 'notifications',
    ECONSENT_APPROVAL = 'edit_document'
}

export const getNotificationIcon = (categoryCode?: string, hasLink?: boolean): string => {
    // eConsent approval: pencil icon
    if (categoryCode === 'econsent-approval') {
        return NotificationCategoryIcon.ECONSENT_APPROVAL;
    }
    // If notification has a link, show action icon
    if (hasLink) {
        return NotificationCategoryIcon.HAS_LINK;
    }
    // Everything else shows default bell icon
    return NotificationCategoryIcon.DEFAULT;
}; 